$(document).ready(function(){
    $(window).scroll(function() {
        if ($(this).scrollTop() > 0) {
            $('#shopify-section-main-password-header').addClass('passwordbg');
        } else {
            $('#shopify-section-main-password-header').removeClass('passwordbg');
        }
    });
});